ion-card-content {
  display: block;
  position: relative;
}

.card-content-ios {
  -webkit-padding-start: 20px;
  padding-inline-start: 20px;
  -webkit-padding-end: 20px;
  padding-inline-end: 20px;
  padding-top: 20px;
  padding-bottom: 20px;
  font-size: 16px;
  line-height: 1.4;
}
.card-content-ios h1 {
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
  margin-bottom: 2px;
  font-size: 24px;
  font-weight: normal;
}
.card-content-ios h2 {
  margin-left: 0;
  margin-right: 0;
  margin-top: 2px;
  margin-bottom: 2px;
  font-size: 16px;
  font-weight: normal;
}
.card-content-ios h3,
.card-content-ios h4,
.card-content-ios h5,
.card-content-ios h6 {
  margin-left: 0;
  margin-right: 0;
  margin-top: 2px;
  margin-bottom: 2px;
  font-size: 14px;
  font-weight: normal;
}
.card-content-ios p {
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
  margin-bottom: 2px;
  font-size: 14px;
}

ion-card-header + .card-content-ios {
  padding-top: 0;
}